import { render, staticRenderFns } from "./YzBtn.vue?vue&type=template&id=71588356&scoped=true&lang=pug&"
import script from "./YzBtn.vue?vue&type=script&lang=js&"
export * from "./YzBtn.vue?vue&type=script&lang=js&"
import style0 from "./YzBtn.vue?vue&type=style&index=0&id=71588356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71588356",
  null
  
)

export default component.exports